
<div class="container min-content-height">
    <div class="form-content">
        
      <div class ="title">
          
         <h2><span class="optional_errortext warning-sign"></span>
          {{authoringContentData?.restrictedPage?.restrictedPageTitleTxt}}
        </h2>
      
      <div class="pageContext">
        <p class="cont-head">{{authoringContentData?.restrictedPage?.accessToPageTxt}}</p>
        <p class="cont-detail">{{authoringContentData?.restrictedPage?.errorContactTxt}}
          <span> {{authoringContentData?.restrictedPage?.phoneContactTxt}} </span>
        </p>
      </div>    
    
      <div class="row" *ngIf="enableLoginButton">
        <div class="col-12 text-center p-b-20">
          <button mat-raised-button (click)="backTologin()" class="secondary_btn">{{authoringContentData?.restrictedPage?.backToLoginTxt}}</button></div>
      </div>
  </div>
    </div>
  </div>